import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { RichTextEditor } from '@/components/rich-text-editor';
/**
 * React-Hook-Form binding for `<RichTextEditor>`. The field value is markdown
 * — the same format the textarea-based editor it replaces stored — so the
 * schema, the API payload and the public page renderer are all untouched by
 * the move to WYSIWYG.
 */
function RichTextFieldInner({ control, name, label, placeholder, disabled, description, className, }) {
    const localId = useId();
    const { t } = useTranslation();
    const defaultHint = t('rich_text.hint', {
        defaultValue: 'Format with the toolbar, or type markdown shortcuts like **bold** and - for a list.',
    });
    return (<FormField control={control} name={name} render={({ field }) => (<FormItem>
                    {label && <FormLabel htmlFor={localId}>{label}</FormLabel>}
                    <RichTextEditor id={localId} value={typeof field.value === 'string' ? field.value : ''} onChange={field.onChange} onBlur={field.onBlur} placeholder={placeholder} disabled={disabled} className={className}/>
                    <FormMessage />
                    {description !== null && <FormDescription>{description ?? defaultHint}</FormDescription>}
                </FormItem>)}/>);
}
RichTextFieldInner.displayName = 'RichTextField';
export const RichTextField = React.memo(RichTextFieldInner);
